// extracted by mini-css-extract-plugin
export default {"productGallery":"uN-z","inQuickShop":"vN-z"};